import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import { calculateNextFiscalQuarter } from "../API/nimbleAPI";

export default function ViewTransactionsFutureRanges(fiscalData = null, isMultiple = false) {
  dayjs.extend(quarterOfYear);

  const nextFiscal = calculateNextFiscalQuarter(fiscalData, isMultiple);
  const nextFiscalStart = nextFiscal ? new Date(nextFiscal.startDate) : null;
  const nextFiscalEnd = nextFiscal ? new Date(nextFiscal.endDate) : null;

  const futureDateOptions = [
    {
      date: "Custom Date Range",
      actualValue: {
        start: null,
        end: null,
      },
    },
    {
      date: "Next 7 Days",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(7, "day").endOf("day").toDate(),
      },
    },
    {
      date: "Next 14 Days",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(14, "day").endOf("day").toDate(),
      },
    },
    {
      date: "Next 30 Days",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(30, "day").endOf("day").toDate(),
      },
    },
    {
      date: "Next 45 Days",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(45, "day").endOf("day").toDate(),
      },
    },
    {
      date: "Next 60 Days",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(60, "day").endOf("day").toDate(),
      },
    },
    {
      date: "Next 90 Days",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(90, "day").endOf("day").toDate(),
      },
    },
    {
      date: "Next 120 Days",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(120, "day").endOf("day").toDate(),
      },
    },
    {
      date: "Next 6 Months",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(6, "month").endOf("day").toDate(),
      },
    },
    {
      date: "Next Fiscal Quarter",
      actualValue: {
        start: nextFiscalStart,
        end: nextFiscalEnd,
      },
    },
    {
      date: "Next 9 Months",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(9, "month").endOf("day").toDate(),
      },
    },
    {
      date: "Next 12 Months (1 Year Forecast)",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(1, "year").endOf("day").toDate(),
      },
    },
  ];

  return futureDateOptions;
}
